// https://github.com/giantcz/gia
// Add import to js/components
import mapboxgl from 'mapbox-gl'
import Component from 'gia/Component'

export default class MapboxComponent extends Component {
  
  constructor(element) {
    super(element);
    this.options = this.getInitialProps();
  }

  getInitialProps () {
    let data = {}
    try {
      data = JSON.parse(document.querySelector('script[type="application/json"]', this).innerText)
    } catch (e) {}
    return data
  }
  
  mount() {
    // console.log('this.options', this.options);
    mapboxgl.accessToken = this.options.access_token;
    const latLng = { lng:`${this.options.longitude}`, lat: `${this.options.latitude}` };
    const map = new mapboxgl.Map({
      container: this.element,
      style: this.options.style,
      zoom: this.options.zoom,
      center: latLng
    })

    if(this.options.popup && this.options.popup !== '') {
      let popupHTML = this.options.popup;

      if(this.options.link && this.options.link !== '') {
        popupHTML += `<div><a href="${this.options.link.url}" class="px-8 py-2 text-white text-center font-medium uppercase tracking-wide bg-primary-500">${this.options.link.title}</a></div>`;
      }

      const popup = new mapboxgl.Popup({ offset: 25, closeOnClick: false, maxWidth: '300px' }).setHTML(popupHTML);

      const marker = new mapboxgl.Marker({ "color": "#e43f16" })
      .setLngLat(latLng)
      .setPopup(popup)
      .addTo(map);
    } else {
      const marker = new mapboxgl.Marker({ "color": "#e43f16" })
      .setLngLat(latLng)
      .addTo(map);
    }
  }
  
}